import React from 'react';
import { motion } from 'framer-motion';
import './styles.scss';
import config from 'config';
import DeleteIcon from 'assets/icons/delete_user_icon.svg';
import EditIcon from 'assets/icons/edit_list_item_icon.svg';
import { gastronomyfilterTableItemContentMotion } from './animation';
import { IGastronomyFilterTableItemProps } from './interface';

function GastronomyFilterTableItem({
    item,
    onDelete,
    onEdit,
}: IGastronomyFilterTableItemProps) {
    const currentDate = new Date();
    return (
        <motion.div
            {...gastronomyfilterTableItemContentMotion}
            className='gastronomy-filter-table-item'
        >
            <div className='gastronomy-filter-table-item__clicable'>
                <div className='gastronomy-filter-table-item__clicable__left-field'>
                    <div className='gastronomy-filter-table-item__clicable__left-field__img'>
                        <img
                            src={`${config.API_URL}/gastronomy/images/${item.Id}?date=${currentDate}`}
                            alt='Item Img'
                        />
                    </div>
                </div>
                <div className='gastronomy-filter-table-item__clicable__left-field'>
                    <p>{item.Gastronomylanguages[0].Name}</p>
                </div>
                <div className='gastronomy-filter-table-item__clicable__right-field'>
                    <p>{item.Gastronomylanguages[0].Description}</p>
                    <button
                        type='button'
                        className='gastronomy-filter-table-item__clicable__right-field__edit-button'
                        onClick={onEdit}
                    >
                        <img src={EditIcon} alt='Edit Icon' />
                    </button>
                    <button
                        type='button'
                        className='gastronomy-filter-table-item__clicable__right-field__delete-button'
                        onClick={onDelete}
                    >
                        <img src={DeleteIcon} alt='Delete Icon' />
                    </button>
                </div>
            </div>
        </motion.div>
    );
}

export default GastronomyFilterTableItem;
